import api from './api';
import { getConfig } from './api';

// 提交运单
export const submitShipment = async (formData) => {
  try {
    const response = await api.post('/submit', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    if (response.data.success) {
      return response.data;
    } else {
      throw new Error(response.data.error || '提交运单失败');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data.error || '提交运单失败');
    }
    throw error;
  }
};

// 查询运单
export const queryShipments = async (params) => {
  try {
    console.log('尝试查询运单，参数:', params);
    const response = await api.get('/query', { params });
    console.log('查询运单响应:', response.data);
    
    // 处理计数查询的特殊情况
    if (params && params.countOnly) {
      console.log('这是一个计数查询');
      // 如果是计数查询，尝试从不同的属性中获取总数
      if (response.data && response.data.pagination && typeof response.data.pagination.total === 'number') {
        return { total: response.data.pagination.total };
      } else if (response.data && typeof response.data.total === 'number') {
        return { total: response.data.total };
      } else if (response.data && response.data.success && typeof response.data.count === 'number') {
        return { total: response.data.count };
      } else if (response.data && response.data.success && response.data.data && typeof response.data.data.total === 'number') {
        return { total: response.data.data.total };
      } else if (response.data && response.data.success && response.data.data && typeof response.data.data.count === 'number') {
        return { total: response.data.data.count };
      } else if (response.data && typeof response.data.count === 'number') {
        return { total: response.data.count };
      } else if (response.data && Array.isArray(response.data)) {
        // 如果响应是数组，返回数组长度作为总数
        return { total: response.data.length };
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        return { total: response.data.data.length };
      } else if (response.data && response.data.items && Array.isArray(response.data.items)) {
        return { total: response.data.items.length };
      }
      
      // 如果没有找到总数信息，返回0
      console.warn('无法从响应中获取总数信息，返回0');
      return { total: 0 };
    }
    
    // 处理各种可能的响应格式
    let shipments = null;
    let pagination = null;
    
    // 先检查最新的响应格式
    if (response.data && response.data.success && response.data.data && Array.isArray(response.data.data)) {
      console.log('使用最新的响应格式: response.data.data (数组)');
      shipments = response.data.data;
      pagination = response.data.pagination || null;
    }
    // 如果不是最新格式，尝试其他可能的格式
    else if (response.data && response.data.success && response.data.shipments) {
      console.log('使用response.data.shipments格式');
      shipments = response.data.shipments;
    } else if (response.data && response.data.success && response.data.data && response.data.data.shipments) {
      // 兼容嵌套在data字段中的格式
      console.log('使用response.data.data.shipments格式');
      shipments = response.data.data.shipments;
    } else if (response.data && Array.isArray(response.data)) {
      // 假设响应本身就是运单数组
      console.log('响应本身就是运单数组');
      shipments = response.data;
    } else if (response.data && response.data.items && Array.isArray(response.data.items)) {
      // 兼容items字段
      console.log('使用response.data.items格式');
      shipments = response.data.items;
    } else {
      // 尝试遍历对象属性，找到第一个数组
      console.log('尝试遍历对象属性找到数组');
      if (response.data && typeof response.data === 'object') {
        for (const key in response.data) {
          if (Array.isArray(response.data[key])) {
            console.log(`使用 ${key} 属性中的数组数据`);
            shipments = response.data[key];
            break;
          }
        }
      }
    }
    
    // 如果找到了运单数据，返回标准格式
    if (shipments !== null) {
      // 处理分页信息
      let total = 0;
      let page = 1;
      let pageSize = 10;
      
      // 如果有分页信息，优先使用
      if (pagination) {
        total = pagination.total || 0;
        page = pagination.page || 1;
        pageSize = pagination.pageSize || 10;
      } else {
        // 尝试从各种可能的属性中获取总数
        total = response.data.total || response.data.count || 
                (response.data.pagination && response.data.pagination.total) ||
                (response.data.data && (response.data.data.total || response.data.data.count)) || 
                shipments.length;
                
        page = response.data.page || 
              (response.data.pagination && response.data.pagination.page) || 1;
              
        pageSize = response.data.pageSize || 
                  (response.data.pagination && response.data.pagination.pageSize) || 
                  shipments.length;
      }
      
      console.log('处理后的分页信息:', { total, page, pageSize });
      
      return {
        items: shipments,
        total: total,
        page: page,
        pageSize: pageSize,
        originalResponse: response.data // 返回原始响应数据便于调试
      };
    }
    
    // 如果没有找到符合格式的运单数据
    console.error('无法解析运单数据格式:', response.data);
    
    // 尝试直接使用 data 字段
    if (response.data && response.data.data && Array.isArray(response.data.data)) {
      console.log('直接使用 response.data.data 数组');
      return {
        items: response.data.data,
        total: response.data.pagination?.total || response.data.data.length,
        page: response.data.pagination?.page || 1,
        pageSize: response.data.pagination?.pageSize || 10,
        originalResponse: response.data
      };
    }
    
    // 如果还是无法解析，返回原始响应数据
    if (response.data && response.status === 200) {
      console.log('尝试直接使用原始响应数据');
      return {
        items: [],
        total: 0,
        page: 1,
        pageSize: 10,
        originalResponse: response.data // 返回原始响应，便于调试
      };
    }
    return { items: [], total: 0, page: 1, pageSize: 10 }; // 返回空数据而不是抛出错误
  } catch (error) {
    console.error('查询运单错误:', error);
    // 返回空数据而不是抛出错误，以避免页面崩溃
    return { items: [], total: 0, page: 1, pageSize: 10 };
  }
};

// 获取单个运单详情
export const getShipment = async (id) => {
  try {
    console.log('开始获取运单详情, ID:', id);
    // 确保ID是有效的
    if (!id) {
      console.error('运单ID无效:', id);
      throw new Error('无效的运单ID');
    }
    
    const response = await api.get(`/shipment?id=${id}`);
    console.log('获取运单详情响应:', response.data);
    
    if (response.data.success) {
      // 如果是对象形式的运单数据
      if (response.data.shipment) {
        const shipment = response.data.shipment;
        console.log('运单数据处理前:', shipment);
        
        // 确保图片URL数组存在且格式正确
        if (shipment.image_urls) {
          console.log('原始图片URLs:', shipment.image_urls);
          
          // 处理图片URL列表
          const processedImageUrls = {
            cargo: Array.isArray(shipment.image_urls.cargo) ? shipment.image_urls.cargo.map(url => {
              // 确保 URL 使用图片服务器域名
              if (url && typeof url === 'string') {
                if (url.includes('localhost') || url.includes('127.0.0.1')) {
                  const fileName = url.split('/').pop().split('?')[0];
                  return `https://imgapi.proxypool.eu.org/${fileName}`;
                }
                // 如果不是完整URL，则添加图片服务器域名
                if (!url.startsWith('http')) {
                  const fileName = url.startsWith('/') ? url.substring(1) : url;
                  return `https://imgapi.proxypool.eu.org/${fileName}`;
                }
              }
              return url;
            }) : [],
            packing: Array.isArray(shipment.image_urls.packing) ? shipment.image_urls.packing.map(url => {
              // 确保 URL 使用图片服务器域名
              if (url && typeof url === 'string') {
                if (url.includes('localhost') || url.includes('127.0.0.1')) {
                  const fileName = url.split('/').pop().split('?')[0];
                  return `https://imgapi.proxypool.eu.org/${fileName}`;
                }
                // 如果不是完整URL，则添加图片服务器域名
                if (!url.startsWith('http')) {
                  const fileName = url.startsWith('/') ? url.substring(1) : url;
                  return `https://imgapi.proxypool.eu.org/${fileName}`;
                }
              }
              return url;
            }) : [],
            shipping: Array.isArray(shipment.image_urls.shipping) ? shipment.image_urls.shipping.map(url => {
              // 确保 URL 使用图片服务器域名
              if (url && typeof url === 'string') {
                if (url.includes('localhost') || url.includes('127.0.0.1')) {
                  const fileName = url.split('/').pop().split('?')[0];
                  return `https://imgapi.proxypool.eu.org/${fileName}`;
                }
                // 如果不是完整URL，则添加图片服务器域名
                if (!url.startsWith('http')) {
                  const fileName = url.startsWith('/') ? url.substring(1) : url;
                  return `https://imgapi.proxypool.eu.org/${fileName}`;
                }
              }
              return url;
            }) : []
          };
          
          // 将处理后的图片URL列表返回
          shipment.image_urls = processedImageUrls;
          console.log('处理后的图片URLs:', processedImageUrls);
          
          // 创建一个合并的图片数组，方便前端显示
          shipment.images = [
            ...processedImageUrls.cargo,
            ...processedImageUrls.packing,
            ...processedImageUrls.shipping
          ];
        } else {
          // 如果没有图片URL，初始化为空对象
          shipment.image_urls = { cargo: [], packing: [], shipping: [] };
          console.log('没有图片URLs，初始化为空对象');
        }
        
        return shipment;
      }
      
      // 如果有data字段，但不是数组，直接返回
      if (response.data.data && typeof response.data.data === 'object' && !Array.isArray(response.data.data)) {
        const shipment = response.data.data;
        console.log('从 data 字段获取运单数据:', shipment);
        
        // 确保图片URL字段存在
        if (!shipment.image_urls) {
          shipment.image_urls = { cargo: [], packing: [], shipping: [] };
        }
        
        return shipment;
      }
      
      // 如果是数组形式的运单数据，取第一个
      if (response.data.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
        const shipment = response.data.data[0];
        console.log('从数组中获取第一个运单数据:', shipment);
        
        // 确保图片URL字段存在
        if (!shipment.image_urls) {
          shipment.image_urls = { cargo: [], packing: [], shipping: [] };
        }
        
        return shipment;
      }
      
      // 尝试获取其他可能的数据结构
      if (response.data.data) {
        // 如果data是对象并包含id
        if (typeof response.data.data === 'object' && response.data.data.id) {
          console.log('从response.data.data获取运单数据');
          return { data: response.data.data };
        }
        // 如果data是数组
        if (Array.isArray(response.data.data) && response.data.data.length > 0) {
          const shipmentItem = response.data.data.find(item => item.id === parseInt(id));
          if (shipmentItem) {
            console.log('从数组中找到匹配ID的运单');
            return { data: shipmentItem };
          }
        }
      }
      
      console.error('响应成功但没有找到匹配的运单数据:', response.data);
      throw new Error('未找到运单数据');
    } else {
      console.error('响应失败:', response.data.message || '未知错误');
      throw new Error(response.data.message || '获取运单详情失败');
    }
  } catch (error) {
    console.error('获取运单详情错误:', error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '获取运单详情失败');
    }
    throw error;
  }
};

// 更新运单
export const updateShipment = async (shipmentData) => {
  try {
    console.log('开始更新运单数据');
    
    // 使用原生fetch API处理FormData提交
    const apiBaseUrl = getConfig().apiBaseUrl || 'https://warehouseapi.proxypool.eu.org';
    const token = localStorage.getItem('auth_token');
    
    // 设置请求头部，但不设置Content-Type
    const headers = {};
    if (token) {
      headers['X-Auth-Token'] = token;
    }
    
    console.log('发送请求头部:', headers);
    
    const response = await fetch(`${apiBaseUrl}/shipment`, {
      method: 'POST',
      headers: headers,
      body: shipmentData, // 直接传入FormData对象
    });
    
    const responseData = await response.json();
    console.log('更新运单响应:', responseData);
    
    if (responseData && responseData.success) {
      return responseData;
    } else {
      console.error('服务器返回错误:', responseData);
      return { success: false, error: responseData?.error || responseData?.message || '更新运单失败' };
    }
      
  } catch (error) {
    console.error('提交运单失败:', error);
    return { success: false, error: error.message || '更新运单失败' };
  }
};

// 创建共享链接
export const createShareableLink = async (shipmentId, options = {}) => {
  try {
    console.log('开始创建共享链接，运单ID:', shipmentId, '类型:', typeof shipmentId);
    
    // 确保 shipmentId 是有效的
    if (!shipmentId) {
      console.error('无效的运单ID:', shipmentId);
      throw new Error('运单ID不能为空');
    }
    
    // 将运单ID转换为字符串
    const stringId = String(shipmentId);
    console.log('转换后的运单ID:', stringId, '类型:', typeof stringId);
    
    const requestData = {
      shipmentId: stringId,
      ...options
    };
    
    console.log('发送请求数据:', requestData);
    
    const response = await api.post('/sharelinks/create', requestData);
    
    console.log('创建共享链接响应:', response.data);
    
    if (response.data && response.data.id) {
      return {
        success: true,
        linkId: response.data.id,
        url: response.data.url,
        expiresAt: response.data.expiresAt
      };
    } else if (response.data && response.data.success) {
      return response.data;
    } else {
      console.error('创建共享链接失败，响应数据:', response.data);
      throw new Error(response.data?.message || '创建共享链接失败');
    }
  } catch (error) {
    console.error('创建共享链接错误:', error);
    if (error.response) {
      console.error('错误响应状态:', error.response.status);
      console.error('错误响应数据:', error.response.data);
      
      if (error.response.data && typeof error.response.data === 'object') {
        throw new Error(error.response.data.message || error.response.data.error || '创建共享链接失败');
      } else if (error.response.data && typeof error.response.data === 'string') {
        throw new Error(error.response.data);
      }
    }
    throw error;
  }
};

// 获取共享链接
export const getShareableLink = async (id, password = null) => {
  try {
    const params = { id };
    if (password) {
      params.password = password;
    }
    
    console.log('请求共享链接，链接ID:', id);
    const response = await api.get('/share/' + id, { params });
    console.log('获取共享链接响应:', response.data);
    
    // 适配后端响应格式
    if (response.data.verified) {
      // 如果有 verified 字段，说明是新的响应格式
      return {
        success: true,
        shipment: response.data.shipment,
        link: response.data.link,
        requiresPassword: response.data.requiresPassword
      };
    } else if (response.data.success) {
      // 兼容旧的响应格式
      return response.data;
    } else if (response.data.requiresPassword) {
      // 需要密码
      return {
        success: false,
        passwordRequired: true,
        message: '此链接需要密码'
      };
    } else {
      throw new Error(response.data.message || '获取共享链接失败');
    }
  } catch (error) {
    console.error('获取共享链接错误:', error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '获取共享链接失败');
    }
    throw error;
  }
};

// 获取运单的所有分享链接
export const getShareableLinks = async (shipmentId) => {
  try {
    console.log('获取运单的分享链接列表，运单ID:', shipmentId);
    
    // 确保 shipmentId 是有效的
    if (!shipmentId) {
      throw new Error('运单ID不能为空');
    }
    
    const response = await api.get(`/sharelinks/${shipmentId}`);
    console.log('获取分享链接列表响应:', response.data);
    
    if (response.data && Array.isArray(response.data)) {
      // 处理过期状态
      const now = Date.now();
      return response.data.map(link => ({
        ...link,
        isExpired: link.expiresAt && now > link.expiresAt
      }));
    } else if (response.data && response.data.links && Array.isArray(response.data.links)) {
      // 兼容可能的不同响应格式
      const now = Date.now();
      return response.data.links.map(link => ({
        ...link,
        isExpired: link.expiresAt && now > link.expiresAt
      }));
    } else {
      return [];
    }
  } catch (error) {
    console.error('获取分享链接列表错误:', error);
    if (error.response && error.response.data) {
      throw new Error(error.response.data.message || '获取分享链接列表失败');
    }
    throw error;
  }
};

// 删除分享链接
export const deleteShareableLink = async (linkId) => {
  try {
    console.log('开始删除分享链接，链接ID:', linkId);
    
    // 确保 linkId 是有效的
    if (!linkId) {
      throw new Error('链接ID不能为空');
    }
    
    const response = await api.delete(`/sharelinks/${linkId}`);
    console.log('删除分享链接响应:', response.data);
    
    if (response.data && response.data.success) {
      return {
        success: true,
        message: '分享链接删除成功'
      };
    } else {
      console.error('删除分享链接失败，响应数据:', response.data);
      throw new Error(response.data?.message || '删除分享链接失败');
    }
  } catch (error) {
    console.error('删除分享链接错误:', error);
    if (error.response) {
      console.error('错误响应状态:', error.response.status);
      console.error('错误响应数据:', error.response.data);
      
      if (error.response.data && typeof error.response.data === 'object') {
        throw new Error(error.response.data.message || error.response.data.error || '删除分享链接失败');
      } else if (error.response.data && typeof error.response.data === 'string') {
        throw new Error(error.response.data);
      }
    }
    throw error;
  }
};

// 删除运单
export const deleteShipment = async (shipmentId) => {
  try {
    console.log('开始删除运单，ID:', shipmentId);
    
    const apiBaseUrl = getConfig().apiBaseUrl || 'https://warehouseapi.proxypool.eu.org';
    const token = localStorage.getItem('auth_token');
    
    const headers = {
      'Content-Type': 'application/json'
    };
    
    if (token) {
      headers['X-Auth-Token'] = token;
    }
    
    const response = await fetch(`${apiBaseUrl}/shipment?id=${shipmentId}`, {
      method: 'DELETE',
      headers: headers
    });
    
    const responseData = await response.json();
    console.log('删除运单响应:', responseData);
    
    if (responseData && responseData.success) {
      return responseData;
    } else {
      console.error('服务器返回错误:', responseData);
      return { success: false, error: responseData?.error || responseData?.message || '删除运单失败' };
    }
      
  } catch (error) {
    console.error('删除运单失败:', error);
    return { success: false, error: error.message || '删除运单失败' };
  }
};
